import { Button, Flex } from "@radix-ui/themes";
import { useParams } from "react-router-dom";

import { useAppSelector } from "@/app/appStore";
import {
  selectAnnotationData,
  selectCurrentCamera,
  selectAnnotationView,
} from "@/entities/annotation";

import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import useCameraHandlers from "../hooks/useCameraHandlers";
import { getDefaultCamerasForStore } from "../lib/helpers";

const DefaultCameras = () => {
  const { storeKey = "" } = useParams<{ storeKey: string }>();
  const defaultCameras = getDefaultCamerasForStore(storeKey);
  const selectedCamera = useAppSelector(selectCurrentCamera);
  const annotationView = useAppSelector(selectAnnotationView);
  const annotationData = useAppSelector(selectAnnotationData);

  const isProximityTimeRangesAnnotation =
    annotationView === ANNOTATION_TYPES.PROXIMITY_TIME_RANGES &&
    !!annotationData;
  const { handleDefaultCameraSelect, cameraData } = useCameraHandlers();

  const renderCameraButton = (cameraId: string) => (
    <Button
      key={cameraId}
      size="1"
      color="gray"
      variant={cameraId === selectedCamera ? "soft" : "ghost"}
      className="m-0"
      disabled={
        !cameraData.allCameras?.some((camera) => camera.id === cameraId) ||
        isProximityTimeRangesAnnotation
      }
      onClick={() => handleDefaultCameraSelect(cameraId)}
    >
      {cameraId}
    </Button>
  );

  if (!defaultCameras.length) {
    return null;
  }

  return (
    <Flex flexGrow="1" minWidth="0" justify="end">
      <Flex className="overflow-x-auto h-full scrollbar-hide dir-rtl">
        <Flex
          direction="row"
          gap="1"
          align="center"
          className="h-full w-max dir-ltr"
        >
          {defaultCameras.map(renderCameraButton)}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DefaultCameras;
